import React, { Component } from 'react'
import './inputError.scss'

export class InputError extends Component {
  render() {
    const { error, side, hidden } = this.props
    const hiddenClass = hidden ? 'hidden' : ''

    return (
      <div className={`input-float ${hiddenClass}`}>
        <div className={`input-error ${side}`}>
          { error }
        </div>
      </div>
    )
  }
}
